module Meevo.Plugins.Register {
    "use strict";

    export class SmartTicketSection extends Meevo.Plugins.Register.RegisterSectionBase {
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Ticket, registerContext, "smartTicket", Register.RegisterSectionCatTypeEnum.Sale);
        }
    }
}